import { GenericHttpClient } from "./config/http.generic.client";
import { useSessionStore } from "../../Stores/Session";
import { Ticket, TicketChatMessage } from "../../Stores/Ticket";
import { useConfigStore } from "../../Stores/Config";

export interface RoadmapBoard {
  column: {
    key: string;
    title: string;
  };
  data: {
    count: number;
    tickets: Ticket[];
  };
}

export class HttpFeatureRequestService extends GenericHttpClient<any> {
  static _instance: HttpFeatureRequestService;
  static getInstance(): HttpFeatureRequestService {
    if (this._instance == null) {
      this._instance = new HttpFeatureRequestService(
        "/v3/shared/feedback-portal/feature-requests"
      );
    }
    return this._instance;
  }

  protected injectToken(
    headers: Record<string, string | boolean>
  ): Record<string, string | boolean> {
    const { session } = useSessionStore.getState();
    const { config } = useConfigStore.getState();

    if (config.defaultDomainHelpCenter) {
      headers["api-token"] = config.defaultDomainHelpCenter;
    }

    if (session && session.gleapId) {
      headers["gleap-id"] = session.gleapId;
    }

    if (session && session.gleapHash) {
      headers["gleap-hash"] = session.gleapHash;
    }

    return headers;
  }

  async getFeatureRequestComments(id: string): Promise<TicketChatMessage[]> {
    const response = await this.get<TicketChatMessage[]>(
      `${this.path}/comments/${id}`
    );
    return response.data;
  }

  async getFeatureList(args: {
    skip: number;
    limit: number;
    sort: string;
    status?: string;
    tagFilter?: string;
  }): Promise<{ tickets: Ticket[] }> {
    const params: Record<string, any> = {
      list: true,
      skip: args.skip,
      limit: args.limit,
      sort: `-${args.sort}`,
    };

    if (args.status) {
      params.status = args.status;
    }

    if (args.tagFilter) {
      params.filter = JSON.stringify({ tags: { $in: [args.tagFilter] } });
    }

    const response = await this.get<{ tickets: Ticket[] }>(this.path, {
      params,
    });
    return response.data;
  }

  async getRoadmapBoard(sort: string): Promise<RoadmapBoard[]> {
    const response = await this.get<RoadmapBoard[]>(this.path, {
      params: { skip: 0, limit: 10, sort: `-${sort}` },
    });
    return response.data;
  }

  async upvoteFeatureRequest(id: string, email: string): Promise<any> {
    const response = await this.post<any>(`${this.path}/vote/${id}`, { email });
    return response.data;
  }

  async addFeatureRequestComment(
    id: string,
    comment: string
  ): Promise<TicketChatMessage> {
    const response = await this.post<TicketChatMessage>(
      `${this.path}/comments/${id}`,
      { comment }
    );
    return response.data;
  }

  async getSessionUpvotes(): Promise<any> {
    const response = await this.get<any>(`${this.path}/upvotes`);
    return response.data;
  }
}
